import { FC } from 'react';
import Slider from 'react-slick';
import { MultiImageContent } from '../types';

interface MultiImageProps {
  content: MultiImageContent;
  onSlideChange: (currentSlide: number) => void;
}

const MultiImage: FC<MultiImageProps> = ({ content, onSlideChange }) => {
  const contentLength = content.length;

  const settings = {
    dots: true,
    infinite: contentLength > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    autoplay: false,
    dotsClass: 'slick-dots tips-modal__slider-dots',
    beforeChange: (_oldIndex: number, newIndex: number) => {
      onSlideChange(newIndex % contentLength);
    },
  };

  return (
    <div className="tips-modal__multi-media-container">
      <Slider {...settings}>
        {content.map(({ url, alt, id }, idx) => (
          <div key={id || idx} className="tips-modal__slide">
            <div className="tips-modal__media-wrapper">
              <img src={url} alt={alt} className="img-fluid tips-modal__media-image" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MultiImage;
